import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { TOOLTIP_TEXTS } from '.';
import { Icon, Tooltip } from '@benzinga/core-ui';
import { RankingPositive } from './RankingPositive';
import { RankingNegative } from './RankingNegative';

export const PriceTrendItem: React.FC<{ trend: string; label: string }> = ({ label, trend }) => {
  const tooltipText = TOOLTIP_TEXTS[label] || '';
  return (
    <div className="price-trend-item gap-2">
      <span className="position-label flex items-center gap-1 mr-1">
        {label}
        <Tooltip content={tooltipText} width={250}>
          <Icon
            className="info-circle-icon text-sm flex items-center justify-center text-[#99AECC]"
            icon={faInfoCircle}
          />
        </Tooltip>
      </span>
      <div className={`position-direction ${trend === 'Y' ? 'positive' : 'negative'}`}>
        {trend === 'Y' ? <RankingPositive /> : <RankingNegative />}
      </div>
    </div>
  );
};
